import { Divider, Grid, Space, Text } from '@mantine/core';
import XSkeleton1Fields from '../../x-components/x-skeletons/x-skeleton-1-fields.component';
import XSkeleton3Fields from '../../x-components/x-skeletons/x-skeleton-3-fields.component';
import XSkeleton4Fields from '../../x-components/x-skeletons/x-skeleton-4-fields.component';

function ViewMIDSkeleton(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const defaultHeight = 14;
  const defaultWidth = '100%';
  return (
    <>
      <Grid>
        <XSkeleton3Fields />
        <XSkeleton4Fields />
        <XSkeleton3Fields />
      </Grid>
      <Divider my='xl' />

      <Text size='xl' weight={700}>
        Rates
      </Text>
      <Space h='xl' />

      <Grid>
        <XSkeleton4Fields />
        <XSkeleton4Fields />
        <XSkeleton3Fields />
        <XSkeleton1Fields />
      </Grid>
    </>
  );
}

export default ViewMIDSkeleton;

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

const labels = {
  partner: 'Partner',
  reseller: 'Reseller',
  merchant: 'Merchant',
  midName: 'MID name',
  switch: 'Switch',

  switchName: 'Switch',
  cardType: 'Card type',
  currency: 'Currency',
  isActive: 'Active status',
  merchantId: 'Merchant ID',

  discountRate: 'Discount',
  cardNotPresent: 'Card not present',
  decline: 'Decline',

  eCommerceRate: 'eCommerce',
  preAuthRate: 'Pre-auth',
  captureRate: 'Capture',

  purchasedRate: 'Purchased',
  refundRate: 'Refund',
  voidRate: 'Void',

  cashBackRate: 'Cashback',
  balanceInquiryRate: 'Balance inquiry',
};
